module.exports = __webpack_public_path__ + "img/gmail.78bce44b.png";